import React from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Home, Package, Upload, LogOut, Clock } from 'react-feather';

export const Layout: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return 'active';
    if (path !== '/' && location.pathname.startsWith(path)) return 'active';
    return '';
  };

  const handleLogout = () => {
    // Redirect to Cloudflare Access logout endpoint
    window.location.href = '/cdn-cgi/access/logout';
  };

  return (
    <div className="app">
      <aside className="sidebar">
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div>
            <h1>MakeStatus Admin</h1>
            <nav>
              <ul className="nav">
                <li>
                  <Link to="/" className={isActive('/')}>
                    <Home size={18} />
                    <span>Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/categories" className={isActive('/categories')}>
                    <Package size={18} />
                    <span>Categories</span>
                  </Link>
                </li>
                <li>
                  <Link to="/upload" className={isActive('/upload')}>
                    <Upload size={18} />
                    <span>Upload</span>
                  </Link>
                </li>
                <li>
                  <Link to="/history" className={isActive('/history')}>
                    <Clock size={18} />
                    <span>History</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div style={{ marginTop: 'auto', paddingTop: '24px', borderTop: '1px solid rgba(255, 255, 255, 0.06)' }}>
            <button
              onClick={handleLogout}
              className="logout-btn"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                padding: '8px 10px',
                background: 'transparent',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: '14px',
                fontWeight: 500,
                cursor: 'pointer',
                borderRadius: '3px',
                transition: 'all 0.15s ease',
                fontFamily: 'Inter, sans-serif'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)';
              }}
            >
              <LogOut size={18} />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
};
